// extracted by mini-css-extract-plugin
export default {"resendOTP":"resend-otp_resendOTP__yhRkK","resendOTPButton":"resend-otp_resendOTPButton__haxIt","resendOtpMessage":"resend-otp_resendOtpMessage__AZ8jh"};